import Home from './pages/Home';

// 소개
import Summary from './pages/introduction/Summary';
import Greeting from './pages/introduction/Greeting';
import Organization from './pages/introduction/Organization';
import IpStartup from './pages/introduction/IpStartup';
import PatentOffice from './pages/introduction/PatentOffice';
import Map from './pages/introduction/Map';

// 프로그램
import Program from './pages/program/Program';
import ProgramDetail from './pages/program/ProgramDetail';
import ProgramApply from './pages/program/ProgramApply';
import Counsel from './pages/program/Counsel';
import CounselInfo from './pages/program/CounselInfo';
import CounselApply from './pages/program/CounselApply';

// 기술소개 투자유치 플랫폼
import PlatformStartup from './pages/platform/PlatformStartup';
import PlatformStartupDetail from './pages/platform/PlatformStartupDetail';
import PlatformPatent from './pages/platform/PlatformPatent';
import PlatformPatentDetail from './pages/platform/PlatformPatentDetail';

// 창업기업 소개
import HospitalStartup from './pages/hospital/HospitalStartup';

// 커뮤니티
import Notice from './pages/community/Notice';
import NoticeDetail from './pages/community/NoticeDetail';
import Schedule from './pages/community/Schedule';
import Archive from './pages/community/Archive';
import ArchiveDetail from './pages/community/ArchiveDetail';
import Inquiry from './pages/community/Inquiry';

// 약관 및 지침
import Terms from './pages/regulation/Terms';
import Email from './pages/regulation/Email';
import Policy from './pages/regulation/Policy';

// 마이페이지
import MyInfo from './pages/mypage/MyInfo';
import MyEdu from './pages/mypage/MyEdu';
import MyInquiry from './pages/mypage/MyInquiry';

// 계정
import Login from './pages/account/Login';
import Signup from './pages/account/Signup';
import SignupRequest from './pages/account/SignupRequest';
import FindLoginId from './pages/account/FindLoginId';
import FindPassword from './pages/account/FindPassword';
import ResetPassword from './pages/account/ResetPassword';
import ResetLoginId from './pages/account/ResetLoginId';

import NotFound from './pages/NotFound';

const routes = [
	{
		id: 0,
		path: '/',
		element: <Home />,
		title: '환영합니다!!!',
	},

	{
		id: 11,
		path: '/introduction/summary',
		element: <Summary />,
		title: '개요 | 소개',
		gnbIndex: 0,
		currentTabIndex: 0,
	},
	{
		id: 12,
		path: '/introduction/greeting',
		element: <Greeting />,
		title: '인사말 | 소개',
		gnbIndex: 0,
		currentTabIndex: 1,
	},
	{
		id: 13,
		path: '/introduction/organization',
		element: <Organization />,
		title: '조직도 | 소개',
		gnbIndex: 0,
		currentTabIndex: 2,
	},
	{
		id: 14,
		path: '/introduction/ipstartup',
		element: <IpStartup />,
		title: '지식재산권과 창업 | 소개',
		gnbIndex: 0,
		currentTabIndex: 3,
	},
	{
		id: 15,
		path: '/introduction/patent-office',
		element: <PatentOffice />,
		title: '전담특허사무소 | 소개',
		gnbIndex: 0,
		currentTabIndex: 4,
	},
	{
		id: 16,
		path: '/introduction/map',
		element: <Map />,
		title: '찾아오시는 길 | 소개',
		gnbIndex: 0,
		currentTabIndex: 6,
	},

	{
		id: 21,
		path: '/program/list',
		element: <Program />,
		title: '프로그램 신청 목록 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 0,
	},
	{
		id: 22,
		path: '/program/list/:id',
		element: <ProgramDetail />,
		title: '프로그램 신청 보기 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 0,
	},
	{
		id: 23,
		path: '/program/apply/:id',
		element: <ProgramApply />,
		title: '프로그램 신청하기 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 0,
	},
	{
		id: 24,
		path: '/counsel/schedule',
		element: <Counsel />,
		title: '1대1 특허상담프로그램(S.T.A.R.T.) 신청 목록 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 1,
	},
	{
		id: 25,
		path: '/counsel/schedule/:id',
		element: <CounselInfo />,
		title: '1대1 특허상담프로그램(S.T.A.R.T.) 신청 정보 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 1,
	},
	{
		id: 26,
		path: '/counsel/apply',
		element: <CounselApply />,
		title: '1대1 특허상담프로그램(S.T.A.R.T.) 신청하기 | 프로그램',
		gnbIndex: 1,
		currentTabIndex: 1,
	},

	{
		id: 31,
		path: '/platform/startup',
		element: <PlatformStartup />,
		title: 'Startup 목록 | 기술소개 투자유치 플랫폼',
		gnbIndex: 2,
		currentTabIndex: 0,
	},
	{
		id: 32,
		path: '/platform/startup/:id',
		element: <PlatformStartupDetail />,
		title: 'Startup 보기 | 기술소개 투자유치 플랫폼',
		gnbIndex: 2,
		currentTabIndex: 0,
	},
	{
		id: 33,
		path: '/platform/patent',
		element: <PlatformPatent />,
		title: 'Patent 목록 | 기술소개 투자유치 플랫폼',
		gnbIndex: 2,
		currentTabIndex: 1,
	},
	{
		id: 34,
		path: '/platform/patent/:id',
		element: <PlatformPatentDetail />,
		title: 'Patent 보기 | 기술소개 투자유치 플랫폼',
		gnbIndex: 2,
		currentTabIndex: 1,
	},

	{
		id: 41,
		path: '/hospital/startup',
		element: <HospitalStartup />,
		title: '병원 창업기업 | 창업기업 소개',
		gnbIndex: 3,
		currentTabIndex: 0,
	},

	{
		id: 51,
		path: '/community/notice',
		element: <Notice />,
		title: '공지사항 목록 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 0,
	},
	{
		id: 52,
		path: '/community/notice/:id',
		element: <NoticeDetail />,
		title: '공지사항 보기 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 0,
	},
	{
		id: 53,
		path: '/community/schedule',
		element: <Schedule />,
		title: '일정 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 1,
	},
	{
		id: 54,
		path: '/community/archive',
		element: <Archive />,
		title: '자료실 목록 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 2,
	},
	{
		id: 55,
		path: '/community/archive/:id',
		element: <ArchiveDetail />,
		title: '자료실 보기 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 2,
	},
	{
		id: 56,
		path: '/community/inquiry',
		element: <Inquiry />,
		title: '1대1 문의 | 커뮤니티',
		gnbIndex: 4,
		currentTabIndex: 3,
	},

	{
		id: 51,
		path: '/regulation/terms',
		element: <Terms />,
		title: '이용약관',
	},
	{
		id: 52,
		path: '/regulation/policy',
		element: <Policy />,
		title: '개인정보 처리방침',
	},
	{
		id: 53,
		path: '/regulation/email',
		element: <Email />,
		title: '이메일무단수집거부',
	},

	{
		id: 91,
		path: '/mypage/info',
		element: <MyInfo />,
		title: '내 정보 | 마이페이지',
		currentTabIndex: 0,
	},
	{
		id: 92,
		path: '/mypage/education',
		element: <MyEdu />,
		title: '내 교육 | 마이페이지',
		currentTabIndex: 1,
	},
	{
		id: 93,
		path: '/mypage/inquiry',
		element: <MyInquiry />,
		title: '내 문의 | 마이페이지',
		currentTabIndex: 2,
	},

	{
		id: 101,
		path: '/account/login',
		element: <Login />,
		title: '로그인',
	},
	{
		id: 102,
		path: '/account/signup',
		element: <Signup />,
		title: '회원가입 동의',
	},
	{
		id: 103,
		path: '/account/signup/request',
		element: <SignupRequest />,
		title: '회원가입 정보 입력',
	},
	{
		id: 104,
		path: '/account/find/loginid',
		element: <FindLoginId />,
		title: '아이디 찾기',
	},
	{
		id: 105,
		path: '/account/find/password',
		element: <FindPassword />,
		title: '비밀번호 찾기',
	},
	{
		id: 106,
		path: '/account/reset/password',
		element: <ResetPassword />,
		title: '비밀번호 재설정',
	},
	{
		id: 107,
		path: '/account/reset/loginid',
		element: <ResetLoginId />,
		title: '아이디 변경',
	},

	{
		id: 999,
		path: '*',
		element: <NotFound />,
		title: '404 Page not found',
	},
];

export default routes;
